import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: Date; output: Date; }
};

export type AccreditationStatus = {
  readonly id: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

export type AhsFundedSiteTypeEntity = {
  readonly id: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

export type AmenityFilter = {
  readonly accessibleBathroom?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly accessibleBuilding?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly emergencyCallSystem?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly gardens?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly hairdresserBarberServices?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly housekeeping?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly indoorSmokingRoom?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly laundryService?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly mealsIncluded?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly parking?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly privateBathroom?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly safeOutdoorSmokingArea?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly smallPetsAllowed?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly socialActivities?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
};

export type AmentityTypeEntity = {
  readonly fundingType: FundingTypeEntity;
  readonly id: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

export type CapacityReportEntity = {
  readonly capacityReportPeriodDueDate: Scalars['DateTime']['output'];
  readonly capacityReportPeriodEndDate: Scalars['DateTime']['output'];
  readonly capacityReportPeriodId: Scalars['String']['output'];
  readonly capacityReportPeriodStartDate: Scalars['DateTime']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy: Scalars['String']['output'];
  readonly createdByName: Scalars['String']['output'];
  readonly facilityCity: Scalars['String']['output'];
  readonly facilityHasSmokingPolicy?: Maybe<Scalars['Boolean']['output']>;
  readonly facilityId: Scalars['Int']['output'];
  readonly facilityName: Scalars['String']['output'];
  readonly hasEarlierIncompleteReports: Scalars['Boolean']['output'];
  readonly hasOtherReasonForChange?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['String']['output'];
  readonly noChangesFromPreviousReport?: Maybe<Scalars['Boolean']['output']>;
  readonly otherReasonForChange?: Maybe<Scalars['String']['output']>;
  readonly reasonsForChange?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly status: CapacityReportStatus;
  readonly submittedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly submittedBy?: Maybe<Scalars['String']['output']>;
  readonly submittedByName?: Maybe<Scalars['String']['output']>;
  readonly typeAEmptyBedReasons?: Maybe<EmptyBedReasonsType>;
  readonly typeAFundedBedCount: Scalars['Int']['output'];
  readonly typeAHasEmptyBeds?: Maybe<Scalars['Boolean']['output']>;
  readonly typeAOccupiedBedCount?: Maybe<Scalars['Int']['output']>;
  readonly typeAOccupiedBedCountPrevious?: Maybe<Scalars['Int']['output']>;
  readonly typeAOperationalBedCount?: Maybe<Scalars['Int']['output']>;
  readonly typeAOperationalBedCountPrevious?: Maybe<Scalars['Int']['output']>;
  readonly typeAVacantBedCount?: Maybe<Scalars['Int']['output']>;
  readonly typeBEmptyBedReasons?: Maybe<EmptyBedReasonsType>;
  readonly typeBFundedBedCount: Scalars['Int']['output'];
  readonly typeBHasEmptyBeds?: Maybe<Scalars['Boolean']['output']>;
  readonly typeBOccupiedBedCount?: Maybe<Scalars['Int']['output']>;
  readonly typeBOccupiedBedCountPrevious?: Maybe<Scalars['Int']['output']>;
  readonly typeBOperationalBedCount?: Maybe<Scalars['Int']['output']>;
  readonly typeBOperationalBedCountPrevious?: Maybe<Scalars['Int']['output']>;
  readonly typeBSecureEmptyBedReasons?: Maybe<EmptyBedReasonsType>;
  readonly typeBSecureFundedBedCount: Scalars['Int']['output'];
  readonly typeBSecureHasEmptyBeds?: Maybe<Scalars['Boolean']['output']>;
  readonly typeBSecureOccupiedBedCount?: Maybe<Scalars['Int']['output']>;
  readonly typeBSecureOccupiedBedCountPrevious?: Maybe<Scalars['Int']['output']>;
  readonly typeBSecureOperationalBedCount?: Maybe<Scalars['Int']['output']>;
  readonly typeBSecureOperationalBedCountPrevious?: Maybe<Scalars['Int']['output']>;
  readonly typeBSecureVacantBedCount?: Maybe<Scalars['Int']['output']>;
  readonly typeBVacantBedCount?: Maybe<Scalars['Int']['output']>;
  readonly typeCEmptyBedReasons?: Maybe<EmptyBedReasonsType>;
  readonly typeCFundedBedCount: Scalars['Int']['output'];
  readonly typeCHasEmptyBeds?: Maybe<Scalars['Boolean']['output']>;
  readonly typeCOccupiedBedCount?: Maybe<Scalars['Int']['output']>;
  readonly typeCOccupiedBedCountPrevious?: Maybe<Scalars['Int']['output']>;
  readonly typeCOperationalBedCount?: Maybe<Scalars['Int']['output']>;
  readonly typeCOperationalBedCountPrevious?: Maybe<Scalars['Int']['output']>;
  readonly typeCVacantBedCount?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly updatedBy: Scalars['String']['output'];
  readonly updatedByName: Scalars['String']['output'];
};

export type CapacityReportOrderByInput = {
  readonly capacityReportPeriodDueDate?: InputMaybe<Sort>;
  readonly facilityName?: InputMaybe<Sort>;
  readonly submittedAt?: InputMaybe<Sort>;
};

/** The status of the capacity report */
export enum CapacityReportStatus {
  COMPLETED = 'Completed',
  INPROGRESS = 'InProgress',
  NOTSTARTED = 'NotStarted'
}

export type CapacityUserEntity = {
  readonly capacityCoordinator: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly middleName?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ChargeEntity = {
  readonly amount?: Maybe<Scalars['Float']['output']>;
  readonly amountDescription?: Maybe<Scalars['String']['output']>;
  readonly chargeType: ChargeTypeEntity;
  readonly facitlityId: Scalars['Int']['output'];
  readonly frequency?: Maybe<Scalars['String']['output']>;
  readonly fundingType?: Maybe<FundingTypeEntity>;
  readonly id: Scalars['Int']['output'];
  readonly isMandatory?: Maybe<Scalars['Boolean']['output']>;
  readonly refundAmount?: Maybe<Scalars['Float']['output']>;
  readonly refundType?: Maybe<Scalars['String']['output']>;
};

export type ChargeTypeEntity = {
  readonly active: Scalars['Boolean']['output'];
  readonly code: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

export type CoordinateDto = {
  readonly latitude: Scalars['Float']['input'];
  readonly longitude: Scalars['Float']['input'];
};

export type EmptyBedReasonsInput = {
  readonly bedMismatchClientRefusal?: InputMaybe<Scalars['Int']['input']>;
  readonly bedMismatchClientRefusalPrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly bedMismatchCognitive?: InputMaybe<Scalars['Int']['input']>;
  readonly bedMismatchCognitivePrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly bedMismatchEquipment?: InputMaybe<Scalars['Int']['input']>;
  readonly bedMismatchEquipmentPrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly bedMismatchPeerGender?: InputMaybe<Scalars['Int']['input']>;
  readonly bedMismatchPeerGenderPrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly bedMismatchPhysical?: InputMaybe<Scalars['Int']['input']>;
  readonly bedMismatchPhysicalPrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly bedMismatchSmoking?: InputMaybe<Scalars['Int']['input']>;
  readonly bedMismatchSmokingPrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly onHoldMismatches?: InputMaybe<Scalars['Int']['input']>;
  readonly onHoldMismatchesPrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly onHoldPendingOrMatched?: InputMaybe<Scalars['Int']['input']>;
  readonly onHoldPendingOrMatchedPrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly openBedLessTwoWeekReferral?: InputMaybe<Scalars['Int']['input']>;
  readonly openBedLessTwoWeekReferralPrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly openBedTwoWeekNoReferral?: InputMaybe<Scalars['Int']['input']>;
  readonly openBedTwoWeekNoReferralPrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly tempCloseEmergencyResponse?: InputMaybe<Scalars['Int']['input']>;
  readonly tempCloseEmergencyResponsePrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly tempCloseInfectionControl?: InputMaybe<Scalars['Int']['input']>;
  readonly tempCloseInfectionControlPrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly tempCloseMaintenance?: InputMaybe<Scalars['Int']['input']>;
  readonly tempCloseMaintenancePrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly tempCloseOther?: InputMaybe<Scalars['Int']['input']>;
  readonly tempCloseOtherPrevious?: InputMaybe<Scalars['Int']['input']>;
  readonly tempCloseReasonForOther?: InputMaybe<Scalars['String']['input']>;
  readonly tempCloseReasonForOtherPrevious?: InputMaybe<Scalars['String']['input']>;
  readonly tempCloseStaffingIssue?: InputMaybe<Scalars['Int']['input']>;
  readonly tempCloseStaffingIssuePrevious?: InputMaybe<Scalars['Int']['input']>;
};

export type EmptyBedReasonsType = {
  readonly bedMismatchClientRefusal?: Maybe<Scalars['Int']['output']>;
  readonly bedMismatchClientRefusalPrevious?: Maybe<Scalars['Int']['output']>;
  readonly bedMismatchCognitive?: Maybe<Scalars['Int']['output']>;
  readonly bedMismatchCognitivePrevious?: Maybe<Scalars['Int']['output']>;
  readonly bedMismatchEquipment?: Maybe<Scalars['Int']['output']>;
  readonly bedMismatchEquipmentPrevious?: Maybe<Scalars['Int']['output']>;
  readonly bedMismatchPeerGender?: Maybe<Scalars['Int']['output']>;
  readonly bedMismatchPeerGenderPrevious?: Maybe<Scalars['Int']['output']>;
  readonly bedMismatchPhysical?: Maybe<Scalars['Int']['output']>;
  readonly bedMismatchPhysicalPrevious?: Maybe<Scalars['Int']['output']>;
  readonly bedMismatchSmoking?: Maybe<Scalars['Int']['output']>;
  readonly bedMismatchSmokingPrevious?: Maybe<Scalars['Int']['output']>;
  readonly onHoldMismatches?: Maybe<Scalars['Int']['output']>;
  readonly onHoldMismatchesPrevious?: Maybe<Scalars['Int']['output']>;
  readonly onHoldPendingOrMatched?: Maybe<Scalars['Int']['output']>;
  readonly onHoldPendingOrMatchedPrevious?: Maybe<Scalars['Int']['output']>;
  readonly openBedLessTwoWeekReferral?: Maybe<Scalars['Int']['output']>;
  readonly openBedLessTwoWeekReferralPrevious?: Maybe<Scalars['Int']['output']>;
  readonly openBedTwoWeekNoReferral?: Maybe<Scalars['Int']['output']>;
  readonly openBedTwoWeekNoReferralPrevious?: Maybe<Scalars['Int']['output']>;
  readonly tempCloseEmergencyResponse?: Maybe<Scalars['Int']['output']>;
  readonly tempCloseEmergencyResponsePrevious?: Maybe<Scalars['Int']['output']>;
  readonly tempCloseInfectionControl?: Maybe<Scalars['Int']['output']>;
  readonly tempCloseInfectionControlPrevious?: Maybe<Scalars['Int']['output']>;
  readonly tempCloseMaintenance?: Maybe<Scalars['Int']['output']>;
  readonly tempCloseMaintenancePrevious?: Maybe<Scalars['Int']['output']>;
  readonly tempCloseOther?: Maybe<Scalars['Int']['output']>;
  readonly tempCloseOtherPrevious?: Maybe<Scalars['Int']['output']>;
  readonly tempCloseReasonForOther?: Maybe<Scalars['String']['output']>;
  readonly tempCloseReasonForOtherPrevious?: Maybe<Scalars['String']['output']>;
  readonly tempCloseStaffingIssue?: Maybe<Scalars['Int']['output']>;
  readonly tempCloseStaffingIssuePrevious?: Maybe<Scalars['Int']['output']>;
};

export type FacilityEntity = {
  readonly accomodationsStandardsUrl?: Maybe<Scalars['String']['output']>;
  readonly accreditationOrganizationName?: Maybe<Scalars['String']['output']>;
  readonly accreditationOrganizationUrl?: Maybe<Scalars['String']['output']>;
  readonly accreditationStatus?: Maybe<AccreditationStatus>;
  readonly accreditationStatusId?: Maybe<Scalars['Int']['output']>;
  readonly addressLine1: Scalars['String']['output'];
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  readonly ahsFundedSiteTypes?: Maybe<ReadonlyArray<AhsFundedSiteTypeEntity>>;
  readonly amenityTypes?: Maybe<ReadonlyArray<AmentityTypeEntity>>;
  readonly buildDate?: Maybe<Scalars['Int']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly corridor?: Maybe<Scalars['String']['output']>;
  readonly country?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy: Scalars['String']['output'];
  readonly createdByName: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly facilityCharges?: Maybe<ReadonlyArray<ChargeEntity>>;
  readonly faxNumber?: Maybe<Scalars['String']['output']>;
  readonly foodServiceTypes?: Maybe<ReadonlyArray<FoodServiceEntity>>;
  readonly fundingType?: Maybe<FundingTypeEntity>;
  readonly hasSmokingPolicy?: Maybe<Scalars['Boolean']['output']>;
  readonly hideExactLocation: Scalars['Boolean']['output'];
  readonly id: Scalars['Int']['output'];
  readonly images?: Maybe<ReadonlyArray<ImageEntity>>;
  readonly latitude: Scalars['Float']['output'];
  readonly longitude: Scalars['Float']['output'];
  readonly name: Scalars['String']['output'];
  readonly nonAhsFundedSiteTypes?: Maybe<ReadonlyArray<NonAhsFundedSiteTypeEntity>>;
  readonly numberOfSpacesAccessibleB?: Maybe<Scalars['Int']['output']>;
  readonly numberOfSpacesMultiBedroom?: Maybe<Scalars['Int']['output']>;
  readonly numberOfSpacesOneBedroom?: Maybe<Scalars['Int']['output']>;
  readonly numberOfSpacesPrivateRoom?: Maybe<Scalars['Int']['output']>;
  readonly numberOfSpacesSharedRoom?: Maybe<Scalars['Int']['output']>;
  readonly operatorWebsite?: Maybe<Scalars['String']['output']>;
  readonly operator_name?: Maybe<Scalars['String']['output']>;
  readonly operator_type?: Maybe<Scalars['String']['output']>;
  readonly organizationId: Scalars['Int']['output'];
  readonly otherServicesThroughAHSCaseManager?: Maybe<Scalars['String']['output']>;
  readonly otherServicesThroughSiteDirectly?: Maybe<Scalars['String']['output']>;
  readonly otherServicesThroughZonePalliativeAndEndOfLifeCareTeams?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  readonly province?: Maybe<Scalars['String']['output']>;
  readonly roomPricings?: Maybe<ReadonlyArray<RoomPricingEntity>>;
  readonly roomTypes?: Maybe<ReadonlyArray<RoomTypeEntity>>;
  readonly securityServiceTypes?: Maybe<ReadonlyArray<SecurityServiceTypeEntity>>;
  readonly seniorLodgeBedCount: Scalars['Int']['output'];
  readonly seniorLodgeDesignation?: Maybe<Scalars['Boolean']['output']>;
  readonly seniorLodgeVacantBedCount: Scalars['Int']['output'];
  readonly serviceTypes?: Maybe<ReadonlyArray<SiteServiceTypeEntity>>;
  readonly siteEmail?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly supportedLivingBedCount: Scalars['Int']['output'];
  readonly supportedLivingVacantBedCount: Scalars['Int']['output'];
  readonly titleImage?: Maybe<ImageEntity>;
  readonly transportationServiceTypes?: Maybe<ReadonlyArray<TransportationServiceTypeEntity>>;
  readonly typeAFundedBedCount: Scalars['Int']['output'];
  readonly typeAVacantBedCount: Scalars['Int']['output'];
  readonly typeBFundedBedCount: Scalars['Int']['output'];
  readonly typeBSecureFundedBedCount: Scalars['Int']['output'];
  readonly typeBSecureVacantBedCount: Scalars['Int']['output'];
  readonly typeBVacantBedCount: Scalars['Int']['output'];
  readonly typeCFundedBedCount: Scalars['Int']['output'];
  readonly typeCVacantBedCount: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly updatedBy: Scalars['String']['output'];
  readonly updatedByName: Scalars['String']['output'];
  readonly vacancyType?: Maybe<VacancyType>;
  readonly vacancyTypeId?: Maybe<Scalars['Int']['output']>;
  readonly virtualTourWebsite?: Maybe<Scalars['String']['output']>;
  readonly zoneId: Scalars['Int']['output'];
};

export type FacilityMapItemDto = {
  readonly addressLine1: Scalars['String']['output'];
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly country?: Maybe<Scalars['String']['output']>;
  readonly distanceKm: Scalars['Float']['output'];
  readonly fundingTypeId?: Maybe<Scalars['Int']['output']>;
  readonly fundingTypeTitle?: Maybe<Scalars['String']['output']>;
  readonly hideExactLocation: Scalars['Boolean']['output'];
  readonly id: Scalars['Int']['output'];
  readonly latitude: Scalars['Float']['output'];
  readonly longitude: Scalars['Float']['output'];
  readonly name: Scalars['String']['output'];
  readonly phoneNumber: Scalars['String']['output'];
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  readonly province?: Maybe<Scalars['String']['output']>;
  readonly seniorLodgeBedCount: Scalars['Int']['output'];
  readonly seniorLodgeVacantBedCount: Scalars['Int']['output'];
  readonly supportedLivingBedCount: Scalars['Int']['output'];
  readonly supportedLivingVacantBedCount: Scalars['Int']['output'];
  readonly titleImage?: Maybe<ImageEntity>;
  readonly typeAFundedBedCount: Scalars['Int']['output'];
  readonly typeAVacantBedCount: Scalars['Int']['output'];
  readonly typeBFundedBedCount: Scalars['Int']['output'];
  readonly typeBSecureFundedBedCount: Scalars['Int']['output'];
  readonly typeBSecureVacantBedCount: Scalars['Int']['output'];
  readonly typeBVacantBedCount: Scalars['Int']['output'];
  readonly typeCFundedBedCount: Scalars['Int']['output'];
  readonly typeCVacantBedCount: Scalars['Int']['output'];
};

export type FetchCapacityReportArgs = {
  readonly capacityReportPeriodId?: InputMaybe<Scalars['String']['input']>;
  readonly facilityId?: InputMaybe<Scalars['Int']['input']>;
  readonly orderBy?: InputMaybe<CapacityReportOrderByInput>;
  readonly skip?: InputMaybe<Scalars['Int']['input']>;
  readonly statuses?: InputMaybe<ReadonlyArray<CapacityReportStatus>>;
  readonly take?: InputMaybe<Scalars['Int']['input']>;
};

export type FetchFacilityArgs = {
  readonly amenityFilter?: InputMaybe<AmenityFilter>;
  readonly levelOfCareFilter?: InputMaybe<LevelOfCareFilter>;
  readonly roomTypeFilter?: InputMaybe<RoomTypeFilter>;
  readonly skip?: InputMaybe<Scalars['Int']['input']>;
  readonly take?: InputMaybe<Scalars['Int']['input']>;
};

export type FoodServiceEntity = {
  readonly fundingType: FundingTypeEntity;
  readonly id: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

export type FundingTypeEntity = {
  readonly id: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

export type ImageEntity = {
  readonly altText: Scalars['String']['output'];
  readonly imageUrl: Scalars['String']['output'];
};

export type LevelOfCareFilter = {
  readonly seniorsLodge?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly supportedLiving?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly typeA?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly typeB?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly typeBSecure?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly typeC?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
};

export type Mutation = {
  readonly generateCapacityReports: Scalars['Float']['output'];
  readonly submitAndCompleteCapacityReport: CapacityReportEntity;
  readonly updateAllFacilityVacantBedCounts: Scalars['Float']['output'];
  readonly updateCapacityReport: CapacityReportEntity;
};


export type MutationGenerateCapacityReportsArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSubmitAndCompleteCapacityReportArgs = {
  facilityHasSmokingPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};


export type MutationUpdateAllFacilityVacantBedCountsArgs = {
  facilityIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
};


export type MutationUpdateCapacityReportArgs = {
  updateCapacityReportArgs: UpdateCapacityReportArgs;
};

export type NonAhsFundedSiteTypeEntity = {
  readonly id: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

export type Query = {
  readonly capacityReport: CapacityReportEntity;
  readonly capacityReports: ReadonlyArray<CapacityReportEntity>;
  readonly count: Scalars['Int']['output'];
  readonly facilitiesByBoundingBox: ReadonlyArray<FacilityMapItemDto>;
  readonly facility: FacilityEntity;
  readonly getFirstWeekReportId: Scalars['String']['output'];
  readonly isValidToken: Scalars['Boolean']['output'];
  readonly user: CapacityUserEntity;
};


export type QueryCapacityReportArgs = {
  id: Scalars['String']['input'];
};


export type QueryCapacityReportsArgs = {
  fetchCapacityReportArgs?: InputMaybe<FetchCapacityReportArgs>;
};


export type QueryCountArgs = {
  fetchCapacityReportArgs?: InputMaybe<FetchCapacityReportArgs>;
};


export type QueryFacilitiesByBoundingBoxArgs = {
  coordinateA: CoordinateDto;
  coordinateB: CoordinateDto;
  fetchFacilityArgs?: InputMaybe<FetchFacilityArgs>;
  radiusKm?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilityArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetFirstWeekReportIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryIsValidTokenArgs = {
  token: Scalars['String']['input'];
};

export type RoomPricingEntity = {
  readonly fundingType: FundingTypeEntity;
  readonly id: Scalars['Int']['output'];
  readonly maximumFee: Scalars['Float']['output'];
  readonly minimumFee: Scalars['Float']['output'];
  readonly rentGearedIncome: Scalars['Boolean']['output'];
  readonly roomType: RoomTypeEntity;
};

export type RoomTypeEntity = {
  readonly displayOrder: Scalars['Int']['output'];
  readonly fundingType: FundingTypeEntity;
  readonly id: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

export type RoomTypeFilter = {
  readonly multiBedroom?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly oneBedroom?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly privateRoom?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly sharedRoom?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
};

export type SecurityServiceTypeEntity = {
  readonly fundingType: FundingTypeEntity;
  readonly id: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

export type SiteServiceTypeEntity = {
  readonly fundingType: FundingTypeEntity;
  readonly id: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

/** The orderby sort direction */
export enum Sort {
  ASC = 'asc',
  DESC = 'desc'
}

export type TransportationServiceTypeEntity = {
  readonly fundingType: FundingTypeEntity;
  readonly id: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

export type UpdateCapacityReportArgs = {
  readonly id: Scalars['String']['input'];
  readonly updateCapacityReportInput: UpdateCapacityReportInput;
};

export type UpdateCapacityReportInput = {
  readonly hasOtherReasonForChange?: InputMaybe<Scalars['Boolean']['input']>;
  readonly noChangesFromPreviousReport?: InputMaybe<Scalars['Boolean']['input']>;
  readonly otherReasonForChange?: InputMaybe<Scalars['String']['input']>;
  readonly reasonsForChange?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly typeAEmptyBedReasons?: InputMaybe<EmptyBedReasonsInput>;
  readonly typeAHasEmptyBeds?: InputMaybe<Scalars['Boolean']['input']>;
  readonly typeAOccupiedBedCount?: InputMaybe<Scalars['Int']['input']>;
  readonly typeAOperationalBedCount?: InputMaybe<Scalars['Int']['input']>;
  readonly typeBEmptyBedReasons?: InputMaybe<EmptyBedReasonsInput>;
  readonly typeBHasEmptyBeds?: InputMaybe<Scalars['Boolean']['input']>;
  readonly typeBOccupiedBedCount?: InputMaybe<Scalars['Int']['input']>;
  readonly typeBOperationalBedCount?: InputMaybe<Scalars['Int']['input']>;
  readonly typeBSecureEmptyBedReasons?: InputMaybe<EmptyBedReasonsInput>;
  readonly typeBSecureHasEmptyBeds?: InputMaybe<Scalars['Boolean']['input']>;
  readonly typeBSecureOccupiedBedCount?: InputMaybe<Scalars['Int']['input']>;
  readonly typeBSecureOperationalBedCount?: InputMaybe<Scalars['Int']['input']>;
  readonly typeCEmptyBedReasons?: InputMaybe<EmptyBedReasonsInput>;
  readonly typeCHasEmptyBeds?: InputMaybe<Scalars['Boolean']['input']>;
  readonly typeCOccupiedBedCount?: InputMaybe<Scalars['Int']['input']>;
  readonly typeCOperationalBedCount?: InputMaybe<Scalars['Int']['input']>;
};

export type VacancyType = {
  readonly id: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

export type GetCapacityReportQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCapacityReportQuery = { readonly capacityReport: { readonly id: string, readonly facilityId: number, readonly facilityName: string, readonly facilityCity: string, readonly facilityHasSmokingPolicy?: boolean | null, readonly capacityReportPeriodId: string, readonly capacityReportPeriodStartDate: Date, readonly capacityReportPeriodEndDate: Date, readonly capacityReportPeriodDueDate: Date, readonly status: CapacityReportStatus, readonly reasonsForChange?: ReadonlyArray<string> | null, readonly hasOtherReasonForChange?: boolean | null, readonly otherReasonForChange?: string | null, readonly typeAFundedBedCount: number, readonly typeAOperationalBedCount?: number | null, readonly typeAOccupiedBedCount?: number | null, readonly typeAHasEmptyBeds?: boolean | null, readonly typeBFundedBedCount: number, readonly typeBOperationalBedCount?: number | null, readonly typeBOccupiedBedCount?: number | null, readonly typeBHasEmptyBeds?: boolean | null, readonly typeBSecureFundedBedCount: number, readonly typeBSecureOperationalBedCount?: number | null, readonly typeBSecureOccupiedBedCount?: number | null, readonly typeBSecureHasEmptyBeds?: boolean | null, readonly typeCFundedBedCount: number, readonly typeCOperationalBedCount?: number | null, readonly typeCOccupiedBedCount?: number | null, readonly typeCHasEmptyBeds?: boolean | null, readonly typeAOperationalBedCountPrevious?: number | null, readonly typeAOccupiedBedCountPrevious?: number | null, readonly typeBOperationalBedCountPrevious?: number | null, readonly typeBOccupiedBedCountPrevious?: number | null, readonly typeBSecureOperationalBedCountPrevious?: number | null, readonly typeBSecureOccupiedBedCountPrevious?: number | null, readonly typeCOperationalBedCountPrevious?: number | null, readonly typeCOccupiedBedCountPrevious?: number | null, readonly noChangesFromPreviousReport?: boolean | null, readonly hasEarlierIncompleteReports: boolean, readonly submittedAt?: Date | null, readonly submittedBy?: string | null, readonly submittedByName?: string | null, readonly createdAt: Date, readonly createdBy: string, readonly createdByName: string, readonly updatedAt: Date, readonly updatedBy: string, readonly updatedByName: string, readonly typeAEmptyBedReasons?: { readonly openBedLessTwoWeekReferral?: number | null, readonly openBedLessTwoWeekReferralPrevious?: number | null, readonly openBedTwoWeekNoReferral?: number | null, readonly openBedTwoWeekNoReferralPrevious?: number | null, readonly onHoldPendingOrMatched?: number | null, readonly onHoldPendingOrMatchedPrevious?: number | null, readonly onHoldMismatches?: number | null, readonly onHoldMismatchesPrevious?: number | null, readonly bedMismatchPhysical?: number | null, readonly bedMismatchPhysicalPrevious?: number | null, readonly bedMismatchSmoking?: number | null, readonly bedMismatchSmokingPrevious?: number | null, readonly bedMismatchPeerGender?: number | null, readonly bedMismatchPeerGenderPrevious?: number | null, readonly bedMismatchEquipment?: number | null, readonly bedMismatchEquipmentPrevious?: number | null, readonly bedMismatchCognitive?: number | null, readonly bedMismatchCognitivePrevious?: number | null, readonly bedMismatchClientRefusal?: number | null, readonly bedMismatchClientRefusalPrevious?: number | null, readonly tempCloseEmergencyResponse?: number | null, readonly tempCloseEmergencyResponsePrevious?: number | null, readonly tempCloseInfectionControl?: number | null, readonly tempCloseInfectionControlPrevious?: number | null, readonly tempCloseMaintenance?: number | null, readonly tempCloseMaintenancePrevious?: number | null, readonly tempCloseStaffingIssue?: number | null, readonly tempCloseStaffingIssuePrevious?: number | null, readonly tempCloseOther?: number | null, readonly tempCloseOtherPrevious?: number | null, readonly tempCloseReasonForOther?: string | null, readonly tempCloseReasonForOtherPrevious?: string | null } | null, readonly typeBEmptyBedReasons?: { readonly openBedLessTwoWeekReferral?: number | null, readonly openBedLessTwoWeekReferralPrevious?: number | null, readonly openBedTwoWeekNoReferral?: number | null, readonly openBedTwoWeekNoReferralPrevious?: number | null, readonly onHoldPendingOrMatched?: number | null, readonly onHoldPendingOrMatchedPrevious?: number | null, readonly onHoldMismatches?: number | null, readonly onHoldMismatchesPrevious?: number | null, readonly bedMismatchPhysical?: number | null, readonly bedMismatchPhysicalPrevious?: number | null, readonly bedMismatchSmoking?: number | null, readonly bedMismatchSmokingPrevious?: number | null, readonly bedMismatchPeerGender?: number | null, readonly bedMismatchPeerGenderPrevious?: number | null, readonly bedMismatchEquipment?: number | null, readonly bedMismatchEquipmentPrevious?: number | null, readonly bedMismatchCognitive?: number | null, readonly bedMismatchCognitivePrevious?: number | null, readonly bedMismatchClientRefusal?: number | null, readonly bedMismatchClientRefusalPrevious?: number | null, readonly tempCloseEmergencyResponse?: number | null, readonly tempCloseEmergencyResponsePrevious?: number | null, readonly tempCloseInfectionControl?: number | null, readonly tempCloseInfectionControlPrevious?: number | null, readonly tempCloseMaintenance?: number | null, readonly tempCloseMaintenancePrevious?: number | null, readonly tempCloseStaffingIssue?: number | null, readonly tempCloseStaffingIssuePrevious?: number | null, readonly tempCloseOther?: number | null, readonly tempCloseOtherPrevious?: number | null, readonly tempCloseReasonForOther?: string | null, readonly tempCloseReasonForOtherPrevious?: string | null } | null, readonly typeBSecureEmptyBedReasons?: { readonly openBedLessTwoWeekReferral?: number | null, readonly openBedLessTwoWeekReferralPrevious?: number | null, readonly openBedTwoWeekNoReferral?: number | null, readonly openBedTwoWeekNoReferralPrevious?: number | null, readonly onHoldPendingOrMatched?: number | null, readonly onHoldPendingOrMatchedPrevious?: number | null, readonly onHoldMismatches?: number | null, readonly onHoldMismatchesPrevious?: number | null, readonly bedMismatchPhysical?: number | null, readonly bedMismatchPhysicalPrevious?: number | null, readonly bedMismatchSmoking?: number | null, readonly bedMismatchSmokingPrevious?: number | null, readonly bedMismatchPeerGender?: number | null, readonly bedMismatchPeerGenderPrevious?: number | null, readonly bedMismatchEquipment?: number | null, readonly bedMismatchEquipmentPrevious?: number | null, readonly bedMismatchCognitive?: number | null, readonly bedMismatchCognitivePrevious?: number | null, readonly bedMismatchClientRefusal?: number | null, readonly bedMismatchClientRefusalPrevious?: number | null, readonly tempCloseEmergencyResponse?: number | null, readonly tempCloseEmergencyResponsePrevious?: number | null, readonly tempCloseInfectionControl?: number | null, readonly tempCloseInfectionControlPrevious?: number | null, readonly tempCloseMaintenance?: number | null, readonly tempCloseMaintenancePrevious?: number | null, readonly tempCloseStaffingIssue?: number | null, readonly tempCloseStaffingIssuePrevious?: number | null, readonly tempCloseOther?: number | null, readonly tempCloseOtherPrevious?: number | null, readonly tempCloseReasonForOther?: string | null, readonly tempCloseReasonForOtherPrevious?: string | null } | null, readonly typeCEmptyBedReasons?: { readonly openBedLessTwoWeekReferral?: number | null, readonly openBedLessTwoWeekReferralPrevious?: number | null, readonly openBedTwoWeekNoReferral?: number | null, readonly openBedTwoWeekNoReferralPrevious?: number | null, readonly onHoldPendingOrMatched?: number | null, readonly onHoldPendingOrMatchedPrevious?: number | null, readonly onHoldMismatches?: number | null, readonly onHoldMismatchesPrevious?: number | null, readonly bedMismatchPhysical?: number | null, readonly bedMismatchPhysicalPrevious?: number | null, readonly bedMismatchSmoking?: number | null, readonly bedMismatchSmokingPrevious?: number | null, readonly bedMismatchPeerGender?: number | null, readonly bedMismatchPeerGenderPrevious?: number | null, readonly bedMismatchEquipment?: number | null, readonly bedMismatchEquipmentPrevious?: number | null, readonly bedMismatchCognitive?: number | null, readonly bedMismatchCognitivePrevious?: number | null, readonly bedMismatchClientRefusal?: number | null, readonly bedMismatchClientRefusalPrevious?: number | null, readonly tempCloseEmergencyResponse?: number | null, readonly tempCloseEmergencyResponsePrevious?: number | null, readonly tempCloseInfectionControl?: number | null, readonly tempCloseInfectionControlPrevious?: number | null, readonly tempCloseMaintenance?: number | null, readonly tempCloseMaintenancePrevious?: number | null, readonly tempCloseStaffingIssue?: number | null, readonly tempCloseStaffingIssuePrevious?: number | null, readonly tempCloseOther?: number | null, readonly tempCloseOtherPrevious?: number | null, readonly tempCloseReasonForOther?: string | null, readonly tempCloseReasonForOtherPrevious?: string | null } | null } };

export type GetCapacityReportsCountQueryVariables = Exact<{
  fetchCapacityReportArgs: FetchCapacityReportArgs;
}>;


export type GetCapacityReportsCountQuery = { readonly count: number };

export type GetFirstWeekReportIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetFirstWeekReportIdQuery = { readonly getFirstWeekReportId: string };

export type GetCapacityReportsQueryVariables = Exact<{
  fetchCapacityReportArgs: FetchCapacityReportArgs;
}>;


export type GetCapacityReportsQuery = { readonly capacityReports: ReadonlyArray<{ readonly id: string, readonly capacityReportPeriodDueDate: Date, readonly submittedAt?: Date | null, readonly facilityName: string, readonly status: CapacityReportStatus, readonly submittedByName?: string | null, readonly hasEarlierIncompleteReports: boolean }> };

export type GetFacilitiesByBoundingBoxQueryVariables = Exact<{
  coordinateA: CoordinateDto;
  coordinateB: CoordinateDto;
  fetchFacilityArgs?: InputMaybe<FetchFacilityArgs>;
  radiusKm?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFacilitiesByBoundingBoxQuery = { readonly facilitiesByBoundingBox: ReadonlyArray<{ readonly addressLine1: string, readonly addressLine2?: string | null, readonly city?: string | null, readonly country?: string | null, readonly id: number, readonly latitude: number, readonly longitude: number, readonly name: string, readonly phoneNumber: string, readonly postalCode?: string | null, readonly province?: string | null, readonly typeAFundedBedCount: number, readonly typeBFundedBedCount: number, readonly typeBSecureFundedBedCount: number, readonly typeCFundedBedCount: number, readonly typeAVacantBedCount: number, readonly typeBVacantBedCount: number, readonly typeBSecureVacantBedCount: number, readonly typeCVacantBedCount: number, readonly supportedLivingBedCount: number, readonly seniorLodgeBedCount: number, readonly distanceKm: number, readonly fundingTypeId?: number | null, readonly titleImage?: { readonly imageUrl: string, readonly altText: string } | null }> };

export type GetFacilityQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetFacilityQuery = { readonly facility: { readonly id: number, readonly name: string, readonly addressLine1: string, readonly addressLine2?: string | null, readonly operator_type?: string | null, readonly buildDate?: number | null, readonly city?: string | null, readonly corridor?: string | null, readonly country?: string | null, readonly createdAt: Date, readonly createdBy: string, readonly createdByName: string, readonly description?: string | null, readonly accomodationsStandardsUrl?: string | null, readonly accreditationOrganizationName?: string | null, readonly accreditationOrganizationUrl?: string | null, readonly faxNumber?: string | null, readonly hasSmokingPolicy?: boolean | null, readonly latitude: number, readonly longitude: number, readonly numberOfSpacesAccessibleB?: number | null, readonly numberOfSpacesMultiBedroom?: number | null, readonly numberOfSpacesOneBedroom?: number | null, readonly numberOfSpacesPrivateRoom?: number | null, readonly numberOfSpacesSharedRoom?: number | null, readonly operatorWebsite?: string | null, readonly operator_name?: string | null, readonly organizationId: number, readonly otherServicesThroughAHSCaseManager?: string | null, readonly otherServicesThroughSiteDirectly?: string | null, readonly otherServicesThroughZonePalliativeAndEndOfLifeCareTeams?: string | null, readonly phoneNumber?: string | null, readonly postalCode?: string | null, readonly province?: string | null, readonly seniorLodgeBedCount: number, readonly seniorLodgeDesignation?: boolean | null, readonly siteEmail?: string | null, readonly status?: string | null, readonly supportedLivingBedCount: number, readonly typeAFundedBedCount: number, readonly typeBFundedBedCount: number, readonly typeBSecureFundedBedCount: number, readonly typeCFundedBedCount: number, readonly typeAVacantBedCount: number, readonly typeBVacantBedCount: number, readonly typeBSecureVacantBedCount: number, readonly typeCVacantBedCount: number, readonly updatedAt: Date, readonly updatedBy: string, readonly updatedByName: string, readonly virtualTourWebsite?: string | null, readonly zoneId: number, readonly amenityTypes?: ReadonlyArray<{ readonly id: number, readonly title: string }> | null, readonly ahsFundedSiteTypes?: ReadonlyArray<{ readonly id: number, readonly title: string }> | null, readonly accreditationStatus?: { readonly id: number, readonly title: string } | null, readonly facilityCharges?: ReadonlyArray<{ readonly id: number, readonly amount?: number | null, readonly amountDescription?: string | null, readonly isMandatory?: boolean | null, readonly frequency?: string | null, readonly refundAmount?: number | null, readonly refundType?: string | null, readonly fundingType?: { readonly id: number, readonly title: string } | null, readonly chargeType: { readonly id: number, readonly title: string, readonly description?: string | null, readonly active: boolean, readonly code: string } }> | null, readonly foodServiceTypes?: ReadonlyArray<{ readonly id: number, readonly title: string, readonly fundingType: { readonly id: number, readonly title: string } }> | null, readonly fundingType?: { readonly id: number, readonly title: string } | null, readonly images?: ReadonlyArray<{ readonly imageUrl: string, readonly altText: string }> | null, readonly nonAhsFundedSiteTypes?: ReadonlyArray<{ readonly id: number, readonly title: string }> | null, readonly roomPricings?: ReadonlyArray<{ readonly id: number, readonly maximumFee: number, readonly minimumFee: number, readonly rentGearedIncome: boolean, readonly fundingType: { readonly id: number, readonly title: string }, readonly roomType: { readonly id: number, readonly title: string, readonly displayOrder: number } }> | null, readonly roomTypes?: ReadonlyArray<{ readonly id: number, readonly title: string }> | null, readonly securityServiceTypes?: ReadonlyArray<{ readonly id: number, readonly title: string }> | null, readonly serviceTypes?: ReadonlyArray<{ readonly id: number, readonly title: string, readonly fundingType: { readonly id: number, readonly title: string } }> | null, readonly titleImage?: { readonly imageUrl: string, readonly altText: string } | null, readonly transportationServiceTypes?: ReadonlyArray<{ readonly id: number, readonly title: string }> | null, readonly vacancyType?: { readonly id: number, readonly title: string } | null } };

export type AuthenticateNavAuthQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AuthenticateNavAuthQuery = { readonly isValidToken: boolean };

export type SubmitAndCompleteCapacityReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
  facilityHasSmokingPolicy: Scalars['Boolean']['input'];
}>;


export type SubmitAndCompleteCapacityReportMutation = { readonly submitAndCompleteCapacityReport: { readonly id: string, readonly facilityId: number, readonly facilityName: string, readonly facilityCity: string, readonly capacityReportPeriodId: string, readonly capacityReportPeriodStartDate: Date, readonly capacityReportPeriodEndDate: Date, readonly capacityReportPeriodDueDate: Date, readonly status: CapacityReportStatus, readonly reasonsForChange?: ReadonlyArray<string> | null, readonly hasOtherReasonForChange?: boolean | null, readonly otherReasonForChange?: string | null, readonly typeAFundedBedCount: number, readonly typeAOperationalBedCount?: number | null, readonly typeAOccupiedBedCount?: number | null, readonly typeAHasEmptyBeds?: boolean | null, readonly typeBFundedBedCount: number, readonly typeBOperationalBedCount?: number | null, readonly typeBOccupiedBedCount?: number | null, readonly typeBHasEmptyBeds?: boolean | null, readonly typeBSecureFundedBedCount: number, readonly typeBSecureOperationalBedCount?: number | null, readonly typeBSecureOccupiedBedCount?: number | null, readonly typeBSecureHasEmptyBeds?: boolean | null, readonly typeCFundedBedCount: number, readonly typeCOperationalBedCount?: number | null, readonly typeCOccupiedBedCount?: number | null, readonly typeCHasEmptyBeds?: boolean | null, readonly typeAOperationalBedCountPrevious?: number | null, readonly typeAOccupiedBedCountPrevious?: number | null, readonly typeBOperationalBedCountPrevious?: number | null, readonly typeBOccupiedBedCountPrevious?: number | null, readonly typeBSecureOperationalBedCountPrevious?: number | null, readonly typeBSecureOccupiedBedCountPrevious?: number | null, readonly typeCOperationalBedCountPrevious?: number | null, readonly typeCOccupiedBedCountPrevious?: number | null, readonly noChangesFromPreviousReport?: boolean | null, readonly hasEarlierIncompleteReports: boolean, readonly submittedAt?: Date | null, readonly submittedBy?: string | null, readonly submittedByName?: string | null, readonly createdAt: Date, readonly createdBy: string, readonly createdByName: string, readonly updatedAt: Date, readonly updatedBy: string, readonly updatedByName: string, readonly typeAEmptyBedReasons?: { readonly openBedLessTwoWeekReferral?: number | null, readonly openBedLessTwoWeekReferralPrevious?: number | null, readonly openBedTwoWeekNoReferral?: number | null, readonly openBedTwoWeekNoReferralPrevious?: number | null, readonly onHoldPendingOrMatched?: number | null, readonly onHoldPendingOrMatchedPrevious?: number | null, readonly onHoldMismatches?: number | null, readonly onHoldMismatchesPrevious?: number | null, readonly bedMismatchPhysical?: number | null, readonly bedMismatchPhysicalPrevious?: number | null, readonly bedMismatchSmoking?: number | null, readonly bedMismatchSmokingPrevious?: number | null, readonly bedMismatchPeerGender?: number | null, readonly bedMismatchPeerGenderPrevious?: number | null, readonly bedMismatchEquipment?: number | null, readonly bedMismatchEquipmentPrevious?: number | null, readonly bedMismatchCognitive?: number | null, readonly bedMismatchCognitivePrevious?: number | null, readonly bedMismatchClientRefusal?: number | null, readonly bedMismatchClientRefusalPrevious?: number | null, readonly tempCloseEmergencyResponse?: number | null, readonly tempCloseEmergencyResponsePrevious?: number | null, readonly tempCloseInfectionControl?: number | null, readonly tempCloseInfectionControlPrevious?: number | null, readonly tempCloseMaintenance?: number | null, readonly tempCloseMaintenancePrevious?: number | null, readonly tempCloseStaffingIssue?: number | null, readonly tempCloseStaffingIssuePrevious?: number | null, readonly tempCloseOther?: number | null, readonly tempCloseOtherPrevious?: number | null, readonly tempCloseReasonForOther?: string | null, readonly tempCloseReasonForOtherPrevious?: string | null } | null, readonly typeBEmptyBedReasons?: { readonly openBedLessTwoWeekReferral?: number | null, readonly openBedLessTwoWeekReferralPrevious?: number | null, readonly openBedTwoWeekNoReferral?: number | null, readonly openBedTwoWeekNoReferralPrevious?: number | null, readonly onHoldPendingOrMatched?: number | null, readonly onHoldPendingOrMatchedPrevious?: number | null, readonly onHoldMismatches?: number | null, readonly onHoldMismatchesPrevious?: number | null, readonly bedMismatchPhysical?: number | null, readonly bedMismatchPhysicalPrevious?: number | null, readonly bedMismatchSmoking?: number | null, readonly bedMismatchSmokingPrevious?: number | null, readonly bedMismatchPeerGender?: number | null, readonly bedMismatchPeerGenderPrevious?: number | null, readonly bedMismatchEquipment?: number | null, readonly bedMismatchEquipmentPrevious?: number | null, readonly bedMismatchCognitive?: number | null, readonly bedMismatchCognitivePrevious?: number | null, readonly bedMismatchClientRefusal?: number | null, readonly bedMismatchClientRefusalPrevious?: number | null, readonly tempCloseEmergencyResponse?: number | null, readonly tempCloseEmergencyResponsePrevious?: number | null, readonly tempCloseInfectionControl?: number | null, readonly tempCloseInfectionControlPrevious?: number | null, readonly tempCloseMaintenance?: number | null, readonly tempCloseMaintenancePrevious?: number | null, readonly tempCloseStaffingIssue?: number | null, readonly tempCloseStaffingIssuePrevious?: number | null, readonly tempCloseOther?: number | null, readonly tempCloseOtherPrevious?: number | null, readonly tempCloseReasonForOther?: string | null, readonly tempCloseReasonForOtherPrevious?: string | null } | null, readonly typeBSecureEmptyBedReasons?: { readonly openBedLessTwoWeekReferral?: number | null, readonly openBedLessTwoWeekReferralPrevious?: number | null, readonly openBedTwoWeekNoReferral?: number | null, readonly openBedTwoWeekNoReferralPrevious?: number | null, readonly onHoldPendingOrMatched?: number | null, readonly onHoldPendingOrMatchedPrevious?: number | null, readonly onHoldMismatches?: number | null, readonly onHoldMismatchesPrevious?: number | null, readonly bedMismatchPhysical?: number | null, readonly bedMismatchPhysicalPrevious?: number | null, readonly bedMismatchSmoking?: number | null, readonly bedMismatchSmokingPrevious?: number | null, readonly bedMismatchPeerGender?: number | null, readonly bedMismatchPeerGenderPrevious?: number | null, readonly bedMismatchEquipment?: number | null, readonly bedMismatchEquipmentPrevious?: number | null, readonly bedMismatchCognitive?: number | null, readonly bedMismatchCognitivePrevious?: number | null, readonly bedMismatchClientRefusal?: number | null, readonly bedMismatchClientRefusalPrevious?: number | null, readonly tempCloseEmergencyResponse?: number | null, readonly tempCloseEmergencyResponsePrevious?: number | null, readonly tempCloseInfectionControl?: number | null, readonly tempCloseInfectionControlPrevious?: number | null, readonly tempCloseMaintenance?: number | null, readonly tempCloseMaintenancePrevious?: number | null, readonly tempCloseStaffingIssue?: number | null, readonly tempCloseStaffingIssuePrevious?: number | null, readonly tempCloseOther?: number | null, readonly tempCloseOtherPrevious?: number | null, readonly tempCloseReasonForOther?: string | null, readonly tempCloseReasonForOtherPrevious?: string | null } | null, readonly typeCEmptyBedReasons?: { readonly openBedLessTwoWeekReferral?: number | null, readonly openBedLessTwoWeekReferralPrevious?: number | null, readonly openBedTwoWeekNoReferral?: number | null, readonly openBedTwoWeekNoReferralPrevious?: number | null, readonly onHoldPendingOrMatched?: number | null, readonly onHoldPendingOrMatchedPrevious?: number | null, readonly onHoldMismatches?: number | null, readonly onHoldMismatchesPrevious?: number | null, readonly bedMismatchPhysical?: number | null, readonly bedMismatchPhysicalPrevious?: number | null, readonly bedMismatchSmoking?: number | null, readonly bedMismatchSmokingPrevious?: number | null, readonly bedMismatchPeerGender?: number | null, readonly bedMismatchPeerGenderPrevious?: number | null, readonly bedMismatchEquipment?: number | null, readonly bedMismatchEquipmentPrevious?: number | null, readonly bedMismatchCognitive?: number | null, readonly bedMismatchCognitivePrevious?: number | null, readonly bedMismatchClientRefusal?: number | null, readonly bedMismatchClientRefusalPrevious?: number | null, readonly tempCloseEmergencyResponse?: number | null, readonly tempCloseEmergencyResponsePrevious?: number | null, readonly tempCloseInfectionControl?: number | null, readonly tempCloseInfectionControlPrevious?: number | null, readonly tempCloseMaintenance?: number | null, readonly tempCloseMaintenancePrevious?: number | null, readonly tempCloseStaffingIssue?: number | null, readonly tempCloseStaffingIssuePrevious?: number | null, readonly tempCloseOther?: number | null, readonly tempCloseOtherPrevious?: number | null, readonly tempCloseReasonForOther?: string | null, readonly tempCloseReasonForOtherPrevious?: string | null } | null } };

export type UpdateCapacityReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateCapacityReportInput;
}>;


export type UpdateCapacityReportMutation = { readonly updateCapacityReport: { readonly id: string, readonly facilityId: number, readonly facilityName: string, readonly facilityCity: string, readonly capacityReportPeriodId: string, readonly capacityReportPeriodStartDate: Date, readonly capacityReportPeriodEndDate: Date, readonly capacityReportPeriodDueDate: Date, readonly status: CapacityReportStatus, readonly reasonsForChange?: ReadonlyArray<string> | null, readonly hasOtherReasonForChange?: boolean | null, readonly otherReasonForChange?: string | null, readonly typeAFundedBedCount: number, readonly typeAOperationalBedCount?: number | null, readonly typeAOccupiedBedCount?: number | null, readonly typeAHasEmptyBeds?: boolean | null, readonly typeBFundedBedCount: number, readonly typeBOperationalBedCount?: number | null, readonly typeBOccupiedBedCount?: number | null, readonly typeBHasEmptyBeds?: boolean | null, readonly typeBSecureFundedBedCount: number, readonly typeBSecureOperationalBedCount?: number | null, readonly typeBSecureOccupiedBedCount?: number | null, readonly typeBSecureHasEmptyBeds?: boolean | null, readonly typeCFundedBedCount: number, readonly typeCOperationalBedCount?: number | null, readonly typeCOccupiedBedCount?: number | null, readonly typeCHasEmptyBeds?: boolean | null, readonly typeAOperationalBedCountPrevious?: number | null, readonly typeAOccupiedBedCountPrevious?: number | null, readonly typeBOperationalBedCountPrevious?: number | null, readonly typeBOccupiedBedCountPrevious?: number | null, readonly typeBSecureOperationalBedCountPrevious?: number | null, readonly typeBSecureOccupiedBedCountPrevious?: number | null, readonly typeCOperationalBedCountPrevious?: number | null, readonly typeCOccupiedBedCountPrevious?: number | null, readonly noChangesFromPreviousReport?: boolean | null, readonly hasEarlierIncompleteReports: boolean, readonly submittedAt?: Date | null, readonly submittedBy?: string | null, readonly submittedByName?: string | null, readonly createdAt: Date, readonly createdBy: string, readonly createdByName: string, readonly updatedAt: Date, readonly updatedBy: string, readonly updatedByName: string, readonly typeAEmptyBedReasons?: { readonly openBedLessTwoWeekReferral?: number | null, readonly openBedLessTwoWeekReferralPrevious?: number | null, readonly openBedTwoWeekNoReferral?: number | null, readonly openBedTwoWeekNoReferralPrevious?: number | null, readonly onHoldPendingOrMatched?: number | null, readonly onHoldPendingOrMatchedPrevious?: number | null, readonly onHoldMismatches?: number | null, readonly onHoldMismatchesPrevious?: number | null, readonly bedMismatchPhysical?: number | null, readonly bedMismatchPhysicalPrevious?: number | null, readonly bedMismatchSmoking?: number | null, readonly bedMismatchSmokingPrevious?: number | null, readonly bedMismatchPeerGender?: number | null, readonly bedMismatchPeerGenderPrevious?: number | null, readonly bedMismatchEquipment?: number | null, readonly bedMismatchEquipmentPrevious?: number | null, readonly bedMismatchCognitive?: number | null, readonly bedMismatchCognitivePrevious?: number | null, readonly bedMismatchClientRefusal?: number | null, readonly bedMismatchClientRefusalPrevious?: number | null, readonly tempCloseEmergencyResponse?: number | null, readonly tempCloseEmergencyResponsePrevious?: number | null, readonly tempCloseInfectionControl?: number | null, readonly tempCloseInfectionControlPrevious?: number | null, readonly tempCloseMaintenance?: number | null, readonly tempCloseMaintenancePrevious?: number | null, readonly tempCloseStaffingIssue?: number | null, readonly tempCloseStaffingIssuePrevious?: number | null, readonly tempCloseOther?: number | null, readonly tempCloseOtherPrevious?: number | null, readonly tempCloseReasonForOther?: string | null, readonly tempCloseReasonForOtherPrevious?: string | null } | null, readonly typeBEmptyBedReasons?: { readonly openBedLessTwoWeekReferral?: number | null, readonly openBedLessTwoWeekReferralPrevious?: number | null, readonly openBedTwoWeekNoReferral?: number | null, readonly openBedTwoWeekNoReferralPrevious?: number | null, readonly onHoldPendingOrMatched?: number | null, readonly onHoldPendingOrMatchedPrevious?: number | null, readonly onHoldMismatches?: number | null, readonly onHoldMismatchesPrevious?: number | null, readonly bedMismatchPhysical?: number | null, readonly bedMismatchPhysicalPrevious?: number | null, readonly bedMismatchSmoking?: number | null, readonly bedMismatchSmokingPrevious?: number | null, readonly bedMismatchPeerGender?: number | null, readonly bedMismatchPeerGenderPrevious?: number | null, readonly bedMismatchEquipment?: number | null, readonly bedMismatchEquipmentPrevious?: number | null, readonly bedMismatchCognitive?: number | null, readonly bedMismatchCognitivePrevious?: number | null, readonly bedMismatchClientRefusal?: number | null, readonly bedMismatchClientRefusalPrevious?: number | null, readonly tempCloseEmergencyResponse?: number | null, readonly tempCloseEmergencyResponsePrevious?: number | null, readonly tempCloseInfectionControl?: number | null, readonly tempCloseInfectionControlPrevious?: number | null, readonly tempCloseMaintenance?: number | null, readonly tempCloseMaintenancePrevious?: number | null, readonly tempCloseStaffingIssue?: number | null, readonly tempCloseStaffingIssuePrevious?: number | null, readonly tempCloseOther?: number | null, readonly tempCloseOtherPrevious?: number | null, readonly tempCloseReasonForOther?: string | null, readonly tempCloseReasonForOtherPrevious?: string | null } | null, readonly typeBSecureEmptyBedReasons?: { readonly openBedLessTwoWeekReferral?: number | null, readonly openBedLessTwoWeekReferralPrevious?: number | null, readonly openBedTwoWeekNoReferral?: number | null, readonly openBedTwoWeekNoReferralPrevious?: number | null, readonly onHoldPendingOrMatched?: number | null, readonly onHoldPendingOrMatchedPrevious?: number | null, readonly onHoldMismatches?: number | null, readonly onHoldMismatchesPrevious?: number | null, readonly bedMismatchPhysical?: number | null, readonly bedMismatchPhysicalPrevious?: number | null, readonly bedMismatchSmoking?: number | null, readonly bedMismatchSmokingPrevious?: number | null, readonly bedMismatchPeerGender?: number | null, readonly bedMismatchPeerGenderPrevious?: number | null, readonly bedMismatchEquipment?: number | null, readonly bedMismatchEquipmentPrevious?: number | null, readonly bedMismatchCognitive?: number | null, readonly bedMismatchCognitivePrevious?: number | null, readonly bedMismatchClientRefusal?: number | null, readonly bedMismatchClientRefusalPrevious?: number | null, readonly tempCloseEmergencyResponse?: number | null, readonly tempCloseEmergencyResponsePrevious?: number | null, readonly tempCloseInfectionControl?: number | null, readonly tempCloseInfectionControlPrevious?: number | null, readonly tempCloseMaintenance?: number | null, readonly tempCloseMaintenancePrevious?: number | null, readonly tempCloseStaffingIssue?: number | null, readonly tempCloseStaffingIssuePrevious?: number | null, readonly tempCloseOther?: number | null, readonly tempCloseOtherPrevious?: number | null, readonly tempCloseReasonForOther?: string | null, readonly tempCloseReasonForOtherPrevious?: string | null } | null, readonly typeCEmptyBedReasons?: { readonly openBedLessTwoWeekReferral?: number | null, readonly openBedLessTwoWeekReferralPrevious?: number | null, readonly openBedTwoWeekNoReferral?: number | null, readonly openBedTwoWeekNoReferralPrevious?: number | null, readonly onHoldPendingOrMatched?: number | null, readonly onHoldPendingOrMatchedPrevious?: number | null, readonly onHoldMismatches?: number | null, readonly onHoldMismatchesPrevious?: number | null, readonly bedMismatchPhysical?: number | null, readonly bedMismatchPhysicalPrevious?: number | null, readonly bedMismatchSmoking?: number | null, readonly bedMismatchSmokingPrevious?: number | null, readonly bedMismatchPeerGender?: number | null, readonly bedMismatchPeerGenderPrevious?: number | null, readonly bedMismatchEquipment?: number | null, readonly bedMismatchEquipmentPrevious?: number | null, readonly bedMismatchCognitive?: number | null, readonly bedMismatchCognitivePrevious?: number | null, readonly bedMismatchClientRefusal?: number | null, readonly bedMismatchClientRefusalPrevious?: number | null, readonly tempCloseEmergencyResponse?: number | null, readonly tempCloseEmergencyResponsePrevious?: number | null, readonly tempCloseInfectionControl?: number | null, readonly tempCloseInfectionControlPrevious?: number | null, readonly tempCloseMaintenance?: number | null, readonly tempCloseMaintenancePrevious?: number | null, readonly tempCloseStaffingIssue?: number | null, readonly tempCloseStaffingIssuePrevious?: number | null, readonly tempCloseOther?: number | null, readonly tempCloseOtherPrevious?: number | null, readonly tempCloseReasonForOther?: string | null, readonly tempCloseReasonForOtherPrevious?: string | null } | null } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { readonly user: { readonly id: string, readonly firstName: string, readonly middleName?: string | null, readonly lastName: string, readonly createdAt: Date, readonly updatedAt: Date } };

export const GetCapacityReportDocument = gql`
    query GetCapacityReport($id: String!) {
  capacityReport(id: $id) {
    id
    facilityId
    facilityName
    facilityCity
    facilityHasSmokingPolicy
    capacityReportPeriodId
    capacityReportPeriodStartDate
    capacityReportPeriodEndDate
    capacityReportPeriodDueDate
    status
    reasonsForChange
    hasOtherReasonForChange
    otherReasonForChange
    typeAFundedBedCount
    typeAOperationalBedCount
    typeAOccupiedBedCount
    typeAHasEmptyBeds
    typeAEmptyBedReasons {
      openBedLessTwoWeekReferral
      openBedLessTwoWeekReferralPrevious
      openBedTwoWeekNoReferral
      openBedTwoWeekNoReferralPrevious
      onHoldPendingOrMatched
      onHoldPendingOrMatchedPrevious
      onHoldMismatches
      onHoldMismatchesPrevious
      bedMismatchPhysical
      bedMismatchPhysicalPrevious
      bedMismatchSmoking
      bedMismatchSmokingPrevious
      bedMismatchPeerGender
      bedMismatchPeerGenderPrevious
      bedMismatchEquipment
      bedMismatchEquipmentPrevious
      bedMismatchCognitive
      bedMismatchCognitivePrevious
      bedMismatchClientRefusal
      bedMismatchClientRefusalPrevious
      tempCloseEmergencyResponse
      tempCloseEmergencyResponsePrevious
      tempCloseInfectionControl
      tempCloseInfectionControlPrevious
      tempCloseMaintenance
      tempCloseMaintenancePrevious
      tempCloseStaffingIssue
      tempCloseStaffingIssuePrevious
      tempCloseOther
      tempCloseOtherPrevious
      tempCloseReasonForOther
      tempCloseReasonForOtherPrevious
    }
    typeBFundedBedCount
    typeBOperationalBedCount
    typeBOccupiedBedCount
    typeBHasEmptyBeds
    typeBEmptyBedReasons {
      openBedLessTwoWeekReferral
      openBedLessTwoWeekReferralPrevious
      openBedTwoWeekNoReferral
      openBedTwoWeekNoReferralPrevious
      onHoldPendingOrMatched
      onHoldPendingOrMatchedPrevious
      onHoldMismatches
      onHoldMismatchesPrevious
      bedMismatchPhysical
      bedMismatchPhysicalPrevious
      bedMismatchSmoking
      bedMismatchSmokingPrevious
      bedMismatchPeerGender
      bedMismatchPeerGenderPrevious
      bedMismatchEquipment
      bedMismatchEquipmentPrevious
      bedMismatchCognitive
      bedMismatchCognitivePrevious
      bedMismatchClientRefusal
      bedMismatchClientRefusalPrevious
      tempCloseEmergencyResponse
      tempCloseEmergencyResponsePrevious
      tempCloseInfectionControl
      tempCloseInfectionControlPrevious
      tempCloseMaintenance
      tempCloseMaintenancePrevious
      tempCloseStaffingIssue
      tempCloseStaffingIssuePrevious
      tempCloseOther
      tempCloseOtherPrevious
      tempCloseReasonForOther
      tempCloseReasonForOtherPrevious
    }
    typeBSecureFundedBedCount
    typeBSecureOperationalBedCount
    typeBSecureOccupiedBedCount
    typeBSecureHasEmptyBeds
    typeBSecureEmptyBedReasons {
      openBedLessTwoWeekReferral
      openBedLessTwoWeekReferralPrevious
      openBedTwoWeekNoReferral
      openBedTwoWeekNoReferralPrevious
      onHoldPendingOrMatched
      onHoldPendingOrMatchedPrevious
      onHoldMismatches
      onHoldMismatchesPrevious
      bedMismatchPhysical
      bedMismatchPhysicalPrevious
      bedMismatchSmoking
      bedMismatchSmokingPrevious
      bedMismatchPeerGender
      bedMismatchPeerGenderPrevious
      bedMismatchEquipment
      bedMismatchEquipmentPrevious
      bedMismatchCognitive
      bedMismatchCognitivePrevious
      bedMismatchClientRefusal
      bedMismatchClientRefusalPrevious
      tempCloseEmergencyResponse
      tempCloseEmergencyResponsePrevious
      tempCloseInfectionControl
      tempCloseInfectionControlPrevious
      tempCloseMaintenance
      tempCloseMaintenancePrevious
      tempCloseStaffingIssue
      tempCloseStaffingIssuePrevious
      tempCloseOther
      tempCloseOtherPrevious
      tempCloseReasonForOther
      tempCloseReasonForOtherPrevious
    }
    typeCFundedBedCount
    typeCOperationalBedCount
    typeCOccupiedBedCount
    typeCHasEmptyBeds
    typeCEmptyBedReasons {
      openBedLessTwoWeekReferral
      openBedLessTwoWeekReferralPrevious
      openBedTwoWeekNoReferral
      openBedTwoWeekNoReferralPrevious
      onHoldPendingOrMatched
      onHoldPendingOrMatchedPrevious
      onHoldMismatches
      onHoldMismatchesPrevious
      bedMismatchPhysical
      bedMismatchPhysicalPrevious
      bedMismatchSmoking
      bedMismatchSmokingPrevious
      bedMismatchPeerGender
      bedMismatchPeerGenderPrevious
      bedMismatchEquipment
      bedMismatchEquipmentPrevious
      bedMismatchCognitive
      bedMismatchCognitivePrevious
      bedMismatchClientRefusal
      bedMismatchClientRefusalPrevious
      tempCloseEmergencyResponse
      tempCloseEmergencyResponsePrevious
      tempCloseInfectionControl
      tempCloseInfectionControlPrevious
      tempCloseMaintenance
      tempCloseMaintenancePrevious
      tempCloseStaffingIssue
      tempCloseStaffingIssuePrevious
      tempCloseOther
      tempCloseOtherPrevious
      tempCloseReasonForOther
      tempCloseReasonForOtherPrevious
    }
    typeAOperationalBedCountPrevious
    typeAOccupiedBedCountPrevious
    typeBOperationalBedCountPrevious
    typeBOccupiedBedCountPrevious
    typeBSecureOperationalBedCountPrevious
    typeBSecureOccupiedBedCountPrevious
    typeCOperationalBedCountPrevious
    typeCOccupiedBedCountPrevious
    noChangesFromPreviousReport
    hasEarlierIncompleteReports
    submittedAt
    submittedBy
    submittedByName
    createdAt
    createdBy
    createdByName
    updatedAt
    updatedBy
    updatedByName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCapacityReportGQL extends Apollo.Query<GetCapacityReportQuery, GetCapacityReportQueryVariables> {
    override document = GetCapacityReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCapacityReportsCountDocument = gql`
    query GetCapacityReportsCount($fetchCapacityReportArgs: FetchCapacityReportArgs!) {
  count(fetchCapacityReportArgs: $fetchCapacityReportArgs)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCapacityReportsCountGQL extends Apollo.Query<GetCapacityReportsCountQuery, GetCapacityReportsCountQueryVariables> {
    override document = GetCapacityReportsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFirstWeekReportIdDocument = gql`
    query GetFirstWeekReportId($id: String!) {
  getFirstWeekReportId(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFirstWeekReportIdGQL extends Apollo.Query<GetFirstWeekReportIdQuery, GetFirstWeekReportIdQueryVariables> {
    override document = GetFirstWeekReportIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCapacityReportsDocument = gql`
    query GetCapacityReports($fetchCapacityReportArgs: FetchCapacityReportArgs!) {
  capacityReports(fetchCapacityReportArgs: $fetchCapacityReportArgs) {
    id
    capacityReportPeriodDueDate
    submittedAt
    facilityName
    status
    submittedByName
    hasEarlierIncompleteReports
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCapacityReportsGQL extends Apollo.Query<GetCapacityReportsQuery, GetCapacityReportsQueryVariables> {
    override document = GetCapacityReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFacilitiesByBoundingBoxDocument = gql`
    query GetFacilitiesByBoundingBox($coordinateA: CoordinateDto!, $coordinateB: CoordinateDto!, $fetchFacilityArgs: FetchFacilityArgs, $radiusKm: Int) {
  facilitiesByBoundingBox(
    coordinateA: $coordinateA
    coordinateB: $coordinateB
    fetchFacilityArgs: $fetchFacilityArgs
    radiusKm: $radiusKm
  ) {
    addressLine1
    addressLine2
    city
    country
    id
    latitude
    longitude
    name
    phoneNumber
    postalCode
    province
    typeAFundedBedCount
    typeBFundedBedCount
    typeBSecureFundedBedCount
    typeCFundedBedCount
    typeAVacantBedCount
    typeBVacantBedCount
    typeBSecureVacantBedCount
    typeCVacantBedCount
    supportedLivingBedCount
    seniorLodgeBedCount
    distanceKm
    fundingTypeId
    titleImage {
      imageUrl
      altText
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFacilitiesByBoundingBoxGQL extends Apollo.Query<GetFacilitiesByBoundingBoxQuery, GetFacilitiesByBoundingBoxQueryVariables> {
    override document = GetFacilitiesByBoundingBoxDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFacilityDocument = gql`
    query getFacility($id: Int!) {
  facility(id: $id) {
    id
    name
    addressLine1
    addressLine2
    operator_type
    amenityTypes {
      id
      title
    }
    ahsFundedSiteTypes {
      id
      title
    }
    buildDate
    city
    corridor
    country
    createdAt
    createdBy
    createdByName
    description
    accreditationStatus {
      id
      title
    }
    accomodationsStandardsUrl
    accreditationOrganizationName
    accreditationOrganizationUrl
    facilityCharges {
      id
      amount
      amountDescription
      isMandatory
      frequency
      refundAmount
      refundType
      fundingType {
        id
        title
      }
      chargeType {
        id
        title
        description
        active
        code
      }
    }
    faxNumber
    foodServiceTypes {
      id
      title
      fundingType {
        id
        title
      }
    }
    fundingType {
      id
      title
    }
    hasSmokingPolicy
    images {
      imageUrl
      altText
    }
    latitude
    longitude
    nonAhsFundedSiteTypes {
      id
      title
    }
    numberOfSpacesAccessibleB
    numberOfSpacesMultiBedroom
    numberOfSpacesOneBedroom
    numberOfSpacesPrivateRoom
    numberOfSpacesSharedRoom
    operatorWebsite
    operator_name
    operator_type
    organizationId
    otherServicesThroughAHSCaseManager
    otherServicesThroughSiteDirectly
    otherServicesThroughZonePalliativeAndEndOfLifeCareTeams
    phoneNumber
    postalCode
    province
    roomPricings {
      id
      fundingType {
        id
        title
      }
      roomType {
        id
        title
        displayOrder
      }
      maximumFee
      minimumFee
      rentGearedIncome
    }
    roomTypes {
      id
      title
    }
    securityServiceTypes {
      id
      title
    }
    seniorLodgeBedCount
    seniorLodgeDesignation
    serviceTypes {
      id
      title
      fundingType {
        id
        title
      }
    }
    siteEmail
    securityServiceTypes {
      id
      title
    }
    status
    supportedLivingBedCount
    titleImage {
      imageUrl
      altText
    }
    transportationServiceTypes {
      id
      title
    }
    typeAFundedBedCount
    typeBFundedBedCount
    typeBSecureFundedBedCount
    typeCFundedBedCount
    typeAVacantBedCount
    typeBVacantBedCount
    typeBSecureVacantBedCount
    typeCVacantBedCount
    updatedAt
    updatedBy
    updatedByName
    vacancyType {
      id
      title
    }
    virtualTourWebsite
    zoneId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFacilityGQL extends Apollo.Query<GetFacilityQuery, GetFacilityQueryVariables> {
    override document = GetFacilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AuthenticateNavAuthDocument = gql`
    query AuthenticateNavAuth($token: String!) {
  isValidToken(token: $token)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AuthenticateNavAuthGQL extends Apollo.Query<AuthenticateNavAuthQuery, AuthenticateNavAuthQueryVariables> {
    override document = AuthenticateNavAuthDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitAndCompleteCapacityReportDocument = gql`
    mutation SubmitAndCompleteCapacityReport($id: String!, $facilityHasSmokingPolicy: Boolean!) {
  submitAndCompleteCapacityReport(
    id: $id
    facilityHasSmokingPolicy: $facilityHasSmokingPolicy
  ) {
    id
    facilityId
    facilityName
    facilityCity
    capacityReportPeriodId
    capacityReportPeriodStartDate
    capacityReportPeriodEndDate
    capacityReportPeriodDueDate
    status
    reasonsForChange
    hasOtherReasonForChange
    otherReasonForChange
    typeAFundedBedCount
    typeAOperationalBedCount
    typeAOccupiedBedCount
    typeAHasEmptyBeds
    typeAEmptyBedReasons {
      openBedLessTwoWeekReferral
      openBedLessTwoWeekReferralPrevious
      openBedTwoWeekNoReferral
      openBedTwoWeekNoReferralPrevious
      onHoldPendingOrMatched
      onHoldPendingOrMatchedPrevious
      onHoldMismatches
      onHoldMismatchesPrevious
      bedMismatchPhysical
      bedMismatchPhysicalPrevious
      bedMismatchSmoking
      bedMismatchSmokingPrevious
      bedMismatchPeerGender
      bedMismatchPeerGenderPrevious
      bedMismatchEquipment
      bedMismatchEquipmentPrevious
      bedMismatchCognitive
      bedMismatchCognitivePrevious
      bedMismatchClientRefusal
      bedMismatchClientRefusalPrevious
      tempCloseEmergencyResponse
      tempCloseEmergencyResponsePrevious
      tempCloseInfectionControl
      tempCloseInfectionControlPrevious
      tempCloseMaintenance
      tempCloseMaintenancePrevious
      tempCloseStaffingIssue
      tempCloseStaffingIssuePrevious
      tempCloseOther
      tempCloseOtherPrevious
      tempCloseReasonForOther
      tempCloseReasonForOtherPrevious
    }
    typeBFundedBedCount
    typeBOperationalBedCount
    typeBOccupiedBedCount
    typeBHasEmptyBeds
    typeBEmptyBedReasons {
      openBedLessTwoWeekReferral
      openBedLessTwoWeekReferralPrevious
      openBedTwoWeekNoReferral
      openBedTwoWeekNoReferralPrevious
      onHoldPendingOrMatched
      onHoldPendingOrMatchedPrevious
      onHoldMismatches
      onHoldMismatchesPrevious
      bedMismatchPhysical
      bedMismatchPhysicalPrevious
      bedMismatchSmoking
      bedMismatchSmokingPrevious
      bedMismatchPeerGender
      bedMismatchPeerGenderPrevious
      bedMismatchEquipment
      bedMismatchEquipmentPrevious
      bedMismatchCognitive
      bedMismatchCognitivePrevious
      bedMismatchClientRefusal
      bedMismatchClientRefusalPrevious
      tempCloseEmergencyResponse
      tempCloseEmergencyResponsePrevious
      tempCloseInfectionControl
      tempCloseInfectionControlPrevious
      tempCloseMaintenance
      tempCloseMaintenancePrevious
      tempCloseStaffingIssue
      tempCloseStaffingIssuePrevious
      tempCloseOther
      tempCloseOtherPrevious
      tempCloseReasonForOther
      tempCloseReasonForOtherPrevious
    }
    typeBSecureFundedBedCount
    typeBSecureOperationalBedCount
    typeBSecureOccupiedBedCount
    typeBSecureHasEmptyBeds
    typeBSecureEmptyBedReasons {
      openBedLessTwoWeekReferral
      openBedLessTwoWeekReferralPrevious
      openBedTwoWeekNoReferral
      openBedTwoWeekNoReferralPrevious
      onHoldPendingOrMatched
      onHoldPendingOrMatchedPrevious
      onHoldMismatches
      onHoldMismatchesPrevious
      bedMismatchPhysical
      bedMismatchPhysicalPrevious
      bedMismatchSmoking
      bedMismatchSmokingPrevious
      bedMismatchPeerGender
      bedMismatchPeerGenderPrevious
      bedMismatchEquipment
      bedMismatchEquipmentPrevious
      bedMismatchCognitive
      bedMismatchCognitivePrevious
      bedMismatchClientRefusal
      bedMismatchClientRefusalPrevious
      tempCloseEmergencyResponse
      tempCloseEmergencyResponsePrevious
      tempCloseInfectionControl
      tempCloseInfectionControlPrevious
      tempCloseMaintenance
      tempCloseMaintenancePrevious
      tempCloseStaffingIssue
      tempCloseStaffingIssuePrevious
      tempCloseOther
      tempCloseOtherPrevious
      tempCloseReasonForOther
      tempCloseReasonForOtherPrevious
    }
    typeCFundedBedCount
    typeCOperationalBedCount
    typeCOccupiedBedCount
    typeCHasEmptyBeds
    typeCEmptyBedReasons {
      openBedLessTwoWeekReferral
      openBedLessTwoWeekReferralPrevious
      openBedTwoWeekNoReferral
      openBedTwoWeekNoReferralPrevious
      onHoldPendingOrMatched
      onHoldPendingOrMatchedPrevious
      onHoldMismatches
      onHoldMismatchesPrevious
      bedMismatchPhysical
      bedMismatchPhysicalPrevious
      bedMismatchSmoking
      bedMismatchSmokingPrevious
      bedMismatchPeerGender
      bedMismatchPeerGenderPrevious
      bedMismatchEquipment
      bedMismatchEquipmentPrevious
      bedMismatchCognitive
      bedMismatchCognitivePrevious
      bedMismatchClientRefusal
      bedMismatchClientRefusalPrevious
      tempCloseEmergencyResponse
      tempCloseEmergencyResponsePrevious
      tempCloseInfectionControl
      tempCloseInfectionControlPrevious
      tempCloseMaintenance
      tempCloseMaintenancePrevious
      tempCloseStaffingIssue
      tempCloseStaffingIssuePrevious
      tempCloseOther
      tempCloseOtherPrevious
      tempCloseReasonForOther
      tempCloseReasonForOtherPrevious
    }
    typeAOperationalBedCountPrevious
    typeAOccupiedBedCountPrevious
    typeBOperationalBedCountPrevious
    typeBOccupiedBedCountPrevious
    typeBSecureOperationalBedCountPrevious
    typeBSecureOccupiedBedCountPrevious
    typeCOperationalBedCountPrevious
    typeCOccupiedBedCountPrevious
    noChangesFromPreviousReport
    hasEarlierIncompleteReports
    submittedAt
    submittedBy
    submittedByName
    createdAt
    createdBy
    createdByName
    updatedAt
    updatedBy
    updatedByName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitAndCompleteCapacityReportGQL extends Apollo.Mutation<SubmitAndCompleteCapacityReportMutation, SubmitAndCompleteCapacityReportMutationVariables> {
    override document = SubmitAndCompleteCapacityReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCapacityReportDocument = gql`
    mutation UpdateCapacityReport($id: String!, $input: UpdateCapacityReportInput!) {
  updateCapacityReport(
    updateCapacityReportArgs: {id: $id, updateCapacityReportInput: $input}
  ) {
    id
    facilityId
    facilityName
    facilityCity
    capacityReportPeriodId
    capacityReportPeriodStartDate
    capacityReportPeriodEndDate
    capacityReportPeriodDueDate
    status
    reasonsForChange
    hasOtherReasonForChange
    otherReasonForChange
    typeAFundedBedCount
    typeAOperationalBedCount
    typeAOccupiedBedCount
    typeAHasEmptyBeds
    typeAEmptyBedReasons {
      openBedLessTwoWeekReferral
      openBedLessTwoWeekReferralPrevious
      openBedTwoWeekNoReferral
      openBedTwoWeekNoReferralPrevious
      onHoldPendingOrMatched
      onHoldPendingOrMatchedPrevious
      onHoldMismatches
      onHoldMismatchesPrevious
      bedMismatchPhysical
      bedMismatchPhysicalPrevious
      bedMismatchSmoking
      bedMismatchSmokingPrevious
      bedMismatchPeerGender
      bedMismatchPeerGenderPrevious
      bedMismatchEquipment
      bedMismatchEquipmentPrevious
      bedMismatchCognitive
      bedMismatchCognitivePrevious
      bedMismatchClientRefusal
      bedMismatchClientRefusalPrevious
      tempCloseEmergencyResponse
      tempCloseEmergencyResponsePrevious
      tempCloseInfectionControl
      tempCloseInfectionControlPrevious
      tempCloseMaintenance
      tempCloseMaintenancePrevious
      tempCloseStaffingIssue
      tempCloseStaffingIssuePrevious
      tempCloseOther
      tempCloseOtherPrevious
      tempCloseReasonForOther
      tempCloseReasonForOtherPrevious
    }
    typeBFundedBedCount
    typeBOperationalBedCount
    typeBOccupiedBedCount
    typeBHasEmptyBeds
    typeBEmptyBedReasons {
      openBedLessTwoWeekReferral
      openBedLessTwoWeekReferralPrevious
      openBedTwoWeekNoReferral
      openBedTwoWeekNoReferralPrevious
      onHoldPendingOrMatched
      onHoldPendingOrMatchedPrevious
      onHoldMismatches
      onHoldMismatchesPrevious
      bedMismatchPhysical
      bedMismatchPhysicalPrevious
      bedMismatchSmoking
      bedMismatchSmokingPrevious
      bedMismatchPeerGender
      bedMismatchPeerGenderPrevious
      bedMismatchEquipment
      bedMismatchEquipmentPrevious
      bedMismatchCognitive
      bedMismatchCognitivePrevious
      bedMismatchClientRefusal
      bedMismatchClientRefusalPrevious
      tempCloseEmergencyResponse
      tempCloseEmergencyResponsePrevious
      tempCloseInfectionControl
      tempCloseInfectionControlPrevious
      tempCloseMaintenance
      tempCloseMaintenancePrevious
      tempCloseStaffingIssue
      tempCloseStaffingIssuePrevious
      tempCloseOther
      tempCloseOtherPrevious
      tempCloseReasonForOther
      tempCloseReasonForOtherPrevious
    }
    typeBSecureFundedBedCount
    typeBSecureOperationalBedCount
    typeBSecureOccupiedBedCount
    typeBSecureHasEmptyBeds
    typeBSecureEmptyBedReasons {
      openBedLessTwoWeekReferral
      openBedLessTwoWeekReferralPrevious
      openBedTwoWeekNoReferral
      openBedTwoWeekNoReferralPrevious
      onHoldPendingOrMatched
      onHoldPendingOrMatchedPrevious
      onHoldMismatches
      onHoldMismatchesPrevious
      bedMismatchPhysical
      bedMismatchPhysicalPrevious
      bedMismatchSmoking
      bedMismatchSmokingPrevious
      bedMismatchPeerGender
      bedMismatchPeerGenderPrevious
      bedMismatchEquipment
      bedMismatchEquipmentPrevious
      bedMismatchCognitive
      bedMismatchCognitivePrevious
      bedMismatchClientRefusal
      bedMismatchClientRefusalPrevious
      tempCloseEmergencyResponse
      tempCloseEmergencyResponsePrevious
      tempCloseInfectionControl
      tempCloseInfectionControlPrevious
      tempCloseMaintenance
      tempCloseMaintenancePrevious
      tempCloseStaffingIssue
      tempCloseStaffingIssuePrevious
      tempCloseOther
      tempCloseOtherPrevious
      tempCloseReasonForOther
      tempCloseReasonForOtherPrevious
    }
    typeCFundedBedCount
    typeCOperationalBedCount
    typeCOccupiedBedCount
    typeCHasEmptyBeds
    typeCEmptyBedReasons {
      openBedLessTwoWeekReferral
      openBedLessTwoWeekReferralPrevious
      openBedTwoWeekNoReferral
      openBedTwoWeekNoReferralPrevious
      onHoldPendingOrMatched
      onHoldPendingOrMatchedPrevious
      onHoldMismatches
      onHoldMismatchesPrevious
      bedMismatchPhysical
      bedMismatchPhysicalPrevious
      bedMismatchSmoking
      bedMismatchSmokingPrevious
      bedMismatchPeerGender
      bedMismatchPeerGenderPrevious
      bedMismatchEquipment
      bedMismatchEquipmentPrevious
      bedMismatchCognitive
      bedMismatchCognitivePrevious
      bedMismatchClientRefusal
      bedMismatchClientRefusalPrevious
      tempCloseEmergencyResponse
      tempCloseEmergencyResponsePrevious
      tempCloseInfectionControl
      tempCloseInfectionControlPrevious
      tempCloseMaintenance
      tempCloseMaintenancePrevious
      tempCloseStaffingIssue
      tempCloseStaffingIssuePrevious
      tempCloseOther
      tempCloseOtherPrevious
      tempCloseReasonForOther
      tempCloseReasonForOtherPrevious
    }
    typeAOperationalBedCountPrevious
    typeAOccupiedBedCountPrevious
    typeBOperationalBedCountPrevious
    typeBOccupiedBedCountPrevious
    typeBSecureOperationalBedCountPrevious
    typeBSecureOccupiedBedCountPrevious
    typeCOperationalBedCountPrevious
    typeCOccupiedBedCountPrevious
    noChangesFromPreviousReport
    hasEarlierIncompleteReports
    submittedAt
    submittedBy
    submittedByName
    createdAt
    createdBy
    createdByName
    updatedAt
    updatedBy
    updatedByName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCapacityReportGQL extends Apollo.Mutation<UpdateCapacityReportMutation, UpdateCapacityReportMutationVariables> {
    override document = UpdateCapacityReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  user {
    id
    firstName
    middleName
    lastName
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentUserGQL extends Apollo.Query<GetCurrentUserQuery, GetCurrentUserQueryVariables> {
    override document = GetCurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }